/**
 * Tasks UI Plugin Routes
 */
import { defineRoutes } from '@lognai/plugin-sdk';

export const pluginId = 'tasks';

export const routes = defineRoutes(pluginId, '/tasks', [
  {
    path: '/',
    component: () =>
      import('./pages/TaskBoardPage').then((m) => ({ default: m.TaskBoardPage })),
    name: 'Collaboration',
    description: 'Kanban board of operational tasks',
    // Collaboration feature available to every authenticated user (not gated like
    // shipments/orders) — anyone can be assigned a task and move it across the board.
    nav: {
      icon: { name: 'CheckSquare', size: 20 },
      showInNav: true,
      order: 35,
    },
  },
  {
    path: '/:id',
    component: () =>
      import('./pages/TaskDetailPage').then((m) => ({ default: m.TaskDetailPage })),
    name: 'Task Detail',
    description: 'Task detail, comments and activity',
    parentPath: '/',
    nav: { showInNav: false },
  },
]);
